export default __webpack_public_path__ + "img/pink.e694eed5.png";